import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
})
export class LinkComponent {
  @Input() linkSrc: string | undefined;

  @Input() text: string | undefined;

  @Output() buttonClick = new EventEmitter<void>();

  // constructor() {}

  public onButtonClick() {
    this.buttonClick.emit();
  }
}
